/**
 * WordPress dependencies
 */
import {store, getContext, getElement} from '@wordpress/interactivity';

const {actions} = store('newsletter-signup-block', {
		actions: {
			submit: (event) => {
				event.preventDefault();
				const {ref} = getElement();
				const form = ref.closest('.c-newsletter-signup__form');
				if (form.reportValidity()) {
					actions.recordSignup(form);
				}
			},
			* recordSignup(formElement) {
				const context = getContext();
				const formData = new FormData();

				const name = formElement.querySelector('[name="newsletter-signup-name"]');
				const email = formElement.querySelector('[name="newsletter-signup-email"]');

				formData.append('name', name.value);
				formData.append('email', email.value);
				formData.append('action', 'record_newsletter_signup');
				formData.append('nonce', window.newsletterSignupBlockData.nonce);
				formData.append('postId', context.postId);

				if( window.Intercom ) {
					const intercomUser = window.Intercom('getVisitorId');
					if( intercomUser ) {
						formData.append('intercom_visitor_id', intercomUser);
					}
				}

				try {

					yield fetch(context.ajaxUrl, {
						method: 'POST',
						body: formData
					})
						.then(response => {
							// Check if the response is okay (status in the 200 range)
							if (!response.ok) {
								throw new Error(`HTTP error! status: ${response.status}`);
							}
							return response.json(); // Parse the response as JSON
						})
						.then(responseData => {
							if (responseData.success) {
								context.success = true;
								actions.clearErrorMessage(context);
							} else {
								context.error = true;
								context.errorMessage = responseData.data.message;
							}
						});
				} catch (error) {
					context.status = "error";
					console.errorMessage = "There has been an issue with your submission. Please, try again later."

				}

			},

			clearErrorMessage: (context) => {
				context.error = false;
				context.errorMessage = '';
			}
		}

	})
;
